module.exports = __webpack_public_path__ + "img/20.8bfffe9a.jpg";